import React from "react"

import configs from "config"
const { FileUrl } = configs.client

function StickerSingleMessage({ message }) {
  return (
    <>
      <img
        src={`${FileUrl}/${message.sticker.file}`}
        style={{ maxHeight: "10rem" }}
        alt="Message sticker"
      />
    </>
  )
}

export default StickerSingleMessage
